import { useEffect, useRef } from "react";
import { fetchUserTransactions, nextPage, selectCurrentPage, selectUserTransactionChecks, selectUserTransactions, selectUserTransactionsLoading, selectUserTransactionStores } from "../../model";
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux";
import { BonusTransactionsTable } from "@/widgets/bonus-transactions-table";
import { selectUser, selectUserTransactionsFirstLoad } from "../../model/selectors";

export const TransactionsTab = () => {
    const isFirstRender = useRef(true);
    const user = useAppSelector(selectUser)
    const page = useAppSelector(selectCurrentPage)
    const transactionsFirstLoad = useAppSelector(selectUserTransactionsFirstLoad)
    const stores = useAppSelector(selectUserTransactionStores)
    const checks = useAppSelector(selectUserTransactionChecks)
    const isLoading = useAppSelector(selectUserTransactionsLoading)
    const transactions = useAppSelector(selectUserTransactions)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (!isFirstRender.current && user.id) {
            dispatch(fetchUserTransactions())
        }
    }, [page, user])

    useEffect(() => {
        if (transactionsFirstLoad && user.id) {
            dispatch(fetchUserTransactions())
            isFirstRender.current = false
        }
    }, [user])

    return (
        <BonusTransactionsTable 
            stores={stores} 
            checks={checks} 
            transactions={transactions} 
            isLoading={isLoading} 
            nextPage={() => dispatch(nextPage())}                
        />
    )
}